import { Button } from "@components/Button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@components/Dialog";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

export const PermissionEnabledDialog = ({ onClose, onSave }: { onClose: () => void; onSave: () => void }) => (
	<Dialog open={true} onOpenChange={onClose}>
		<DialogContent className="max-w-130 pb-5">
			<DialogHeader>
				<DialogTitle>Permission to use your content enabled</DialogTitle>
			</DialogHeader>

			<Typography size="sm" className="mb-5">
				I hereby agree to use my content (excl. paid content) for my account promotion, including but not limited to
				social networks.
			</Typography>
			<Typography size="sm" color="msg_time" className="mb-5">
				You can deactivate account promotion at any time. Please note that materials already used will be retained.
			</Typography>

			<Stack direction="row" spacing={8} wide className="gap-2">
				<Button onClick={onSave} wide>
					<Typography size="sm" type="span" weight="bold">
						OK
					</Typography>
				</Button>
				<Button type="secondary" onClick={onClose} wide>
					<Typography size="sm" type="span" weight="bold">
						Cancel
					</Typography>
				</Button>
			</Stack>
		</DialogContent>
	</Dialog>
);
